import { UseMutationOptions } from '@tanstack/react-query';
import { CuredApiPaths } from 'models/enums';
import useMutation from '../useMutation';
import MutationKeys from './keys';

export type NewFolderPostBody = {
    name: string;
};

/**
 * Creates a folder.
 * @param mutateOptions react-query useMutation option
 * @returns the react-query useMutation results
 * See https://react-query-v3.tanstack.com/reference/useMutation for options and return value
 */
const useCreateSegmentFolder = (mutateOptions?: UseMutationOptions<null, Error, NewFolderPostBody>) =>
    useMutation<NewFolderPostBody, null>(
        MutationKeys.CREATE_SEGMENT_FOLDER,
        CuredApiPaths.SEGMENT_FOLDERS,
        mutateOptions
    );

export default useCreateSegmentFolder;
